/**
 * motion-tokens -- canonical motion tokens for all LUKHAS web surfaces.
 *
 * Values are tuned for 60fps targets and respect the 8px / Fibonacci
 * spatial scale used across the design system. Import individual tokens
 * or the full `MotionTokens` object to drive Framer Motion / GSAP
 * transitions in a consistent way.
 */

export const MotionTokens = {
  /** Page / overlay entrance */
  enterScene: { duration: 0.6, ease: [0.23, 1, 0.32, 1] as const },

  /** Page / overlay exit */
  exitScene: { duration: 0.35, ease: [0.55, 0, 1, 0.45] as const },

  /** Staggered card / section reveal */
  sectionReveal: { duration: 0.55, stagger: 0.08 },

  /** Soft attention pulse (scale keyframes) */
  attentionPulse: { duration: 1.1, scale: [1, 1.07, 1] as const },

  /** CTA hover micro-interaction */
  ctaHover: { duration: 0.18, ease: 'easeOut' as const },

  /** Snappy spring for dialogs, popovers, pills */
  springSnap: { type: 'spring' as const, stiffness: 180, damping: 22 },
} as const

export type MotionTokenKey = keyof typeof MotionTokens
